/**
 * HSlider parser: delegates to the shared Slider base (Control + Range +
 * tick/editable properties). HSlider adds no properties of its own; only the
 * draw axis differs, which is the Component's business.
 */
import { parseSlider } from '../shared/slider';
export function parseHSlider(heading, properties) {
    return parseSlider(heading, properties);
}
//# sourceMappingURL=parser.js.map